import { Injectable, Singleton } from "../di/decorators.js";
function Module(metadata) {
    if (void 0 == metadata.singleton) metadata.singleton = true;
    return function(target) {
        if (metadata.singleton) Singleton()(target);
        else Injectable(target);
        target.prototype.metadata = metadata;
        return target;
    };
}
function createModule(metadata) {
    return Module(metadata);
}
function lazyImport(importFn) {
    return async ()=>{
        const module = await importFn();
        if (module && 'object' == typeof module && 'default' in module) return module.default;
        return module;
    };
}
export { Module, createModule, lazyImport };
